export default "__VITE_ASSET__GRFWdaOu__"